import styled from 'styled-components';
import { cn } from '@shadcn/lib/utils';

export const ModeToggle = styled.div.attrs({
  className: 'inline-flex overflow-hidden rounded-lg border border-input',
})``;

export const ModeButton = styled.button.attrs<{ $active?: boolean; $divider?: boolean }>(
  (props) => ({
    type: 'button',
    className: cn(
      'flex items-center gap-1 px-3 py-2 text-sm',
      props.$divider && 'border-l border-input',
      props.$active ? 'bg-vantis-violet text-white' : 'bg-card text-foreground'
    ),
  })
)<{ $active?: boolean; $divider?: boolean }>``;
